import {Layout} from "./Layout.js";
import {MAIL} from "../../constant.js";
import {isWebView} from "../../store.js";
import {mobileOpenMailApp} from "../../../../bridge/renewal-signup/index.js";

export class EmailAuthLayout extends Layout {


    template() {
        const {sectionId = ''} = this.$props;
        return `<section id="${sectionId}" class="signup-wide-pop">
                    <header class="js-section-header"></header>
                    <article>
                        <div class="pop-main js-contents-main">
                            ${this.getMainTextTemplate()}
                            ${this.getSubTextTemplate()}
                            ${this.getNexPageButtonTemplate()}
                            <div class="mail-login-wrap">
                                <button id="" class="js-mail-page-move-btn"  email-type = "${MAIL.GMAIL.NAME}" >${i18next.t(common.open, {val: "Gmail"})} <i class="sign-icons-arrow-right"></i></button>
                                <button id="" class="js-mail-page-move-btn" email-type = "${MAIL.OUTLOOK.NAME}" >${i18next.t(common.open, {val: "Outlook"})} <i class="sign-icons-arrow-right"></i></button>
                            </div>
                        </div>
                    </article>
                </section>`
    }

    getSubTextTemplate() {
        const {subText = ''} = this.$props;
        const Internationalization = Mutil.requireIIFE("Internationalization");
        const isKo = 'ko' === Internationalization?.getCurrentLanguage()?.toLowerCase();
        return !Mutil.empty(subText) ? `<p id="subTxt">${subText} ${isKo ? "으로" : ""}  <br> <span id="authInfoTxt" style="display: none">${i18next.t(main.verificationSent)}</p>` : "";
    }

    showAuthInfoText() {
        $("#authInfoTxt").css("display", "block");
    }

    setEvent() {
        super.setEvent();
        this.addEvent("click", ".js-mail-page-move-btn", this.clickHandlerOfMoveMailPageButton.bind(this))
    }

    clickHandlerOfMoveMailPageButton(e) {
        const $emailBtn = $(e.target).closest(".js-mail-page-move-btn");
        const mailType = $emailBtn.attr("email-type");
        const isWeb = !Mutil.isMobile() && !Mutil.isTablet();
        if (isWeb) {
            this.moveMailWebPage(mailType);
            return;
        }
        if(isWebView()) {
            // APP_NAME은 모바일과 협의된 내용이여서 이름을 변경하기 위해서는 모바일에 공유가 필요!!
            mobileOpenMailApp({ appName : mailType})
            return;
        }
        this.openMailApp(mailType)
    }

    moveMailWebPage(mailType = "") {
        if (Mutil.empty(mailType)) {
            return;
        }
        const link = MAIL[`${mailType}`]?.WEB;
        if (Mutil.empty(link)) {
            return;
        }
        Mutil.open(link, "_blank");
    }

    executeApp(mailType = '') {
        if(Mutil.empty(mailType)) {
            return;
        }
        location.href = MAIL[`${mailType}`]?.SCHEME;
    }

    goStore(mailType = "") {
        if (Mutil.empty(mailType)) {
            return;
        }

        const email =  MAIL[`${mailType}`];
        const isAppStore = "IPHONE" === window._GUBUN || "IPAD" === window._GUBUN;
        if (isAppStore) {
            location.href = email?.APP_STORE;
            return;
        }

        location.href = `market://details?id=${email?.PLAY_STORE}`
    }

    openMailApp(mailType) {
        if (Mutil.empty(mailType)) {
            return;
        }
        Mutil.toast("info", i18next.t(common.goDirect));
        this.executeApp(mailType);
        const timer = setTimeout( () => {
            this.goStore(mailType)
        }, 2000);
    }
}
